/**
 * A moment as every screen writes it: `22 Oct 2026, 4:05 pm IST` (N32, owner 2026-10-23).
 *
 * Activity and Raw Data's *Verified* stamp printed `toLocaleString()` with no locale, so the
 * browser chose: `10/22/2026, 4:05:12 PM` in a US browser, beside screens that write
 * `22 Oct 2026`. An audit trail is read by several people about one firm, so the time is fixed
 * to India's and says so, rather than moving with each viewer's clock.
 *
 * Only the NUMBERS come from `Intl` (they are what the time zone changes); the month's name
 * and the layout are ours, because an engine's short month is not stable — newer ones write
 * `Sept`.
 */

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const IST = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Kolkata',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hourCycle: 'h23',
})

/** `22 Oct 2026, 4:05 pm IST`; a value that is not a moment is shown as it came. */
export function whenWords(iso: string | null | undefined): string {
  if (!iso) return ''
  const at = new Date(iso)
  if (Number.isNaN(at.getTime())) return iso
  const part = Object.fromEntries(IST.formatToParts(at).map((p) => [p.type, p.value]))
  const hour = Number(part.hour) % 24
  const twelve = hour % 12 === 0 ? 12 : hour % 12
  return (
    `${Number(part.day)} ${MONTHS[Number(part.month) - 1]} ${part.year}, ` +
    `${twelve}:${part.minute} ${hour < 12 ? 'am' : 'pm'} IST`
  )
}
